import React from 'react';
import { block } from '../../utils';
import './GroupIndent.css';
const b = block('group-indent');
export const GroupIndent = ({ children }) => (React.createElement("div", { className: b() }, children));
